import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import * as moment from "moment";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";

// import moment from 'moment';
import 'moment/locale/pl'

import {
    Row, 
    Col, 
    Card, 
    CardBody, 
  } from 'reactstrap'

// views
import IndicatorsPage from '../IndicatorsPage'
import Benchmark from "./Benchmark";

// components
import { FilterAvailableDataPoints, UnloggedPlot  } from 'components';
import FilterPanel from '../MyIndicators/FilterPanel'
import DataFilters from '../../../../components/indicatorsComponets/DataFilter/FilterList'

import {
    setStartDate, setEndDate,
} from "actions";
import IndicatorDescription from "./IndicatorDescription";
import {registerLocale} from "react-datepicker";
import pl from "date-fns/locale";
import FilterByDate from "../../../../components/indicatorsComponets/DataFilter/FilterByDate";

const ComparativeIndicatorsPage = ({Filters:{start_date,end_date},Indicators: {available_indicators},PlotData: {active_plot},setStartDate, setEndDate}) => {

    const [startDate, setStart] = useState(new Date(2021,0,1));
    const [endDate, setEnd] = useState(new Date(2021,11,31));

    const checkIfActivePlotNeedsOpkFilter = () => {
        if (available_indicators.length !== 0) {
            let active_indicator_exist = available_indicators.filter(x => x.nazwa === active_plot);
            if (active_indicator_exist.length !== 0) {
                if (active_indicator_exist[0].typ !== "EFP") {
                    return true
                }
            }
        }
        return false
    };

     const setNewStartDate = (date) => {
        if (checkIfActivePlotNeedsOpkFilter()) {
            setStart(date)
            setStartDate(date)
            setEnd(date)
            setEndDate(date)
        } else (
            setStartDateForKrs(date)
        )


    }
    const setNewEndDate = (date) => {
        if (checkIfActivePlotNeedsOpkFilter()) {
           setStart(date)
            setStartDate(date)
            setEnd(date)
            setEndDate(date)

        } else (
            setEndDateForKrs(date)
        )


    }



    const setStartDateForKrs = (date) => {
        let tmpDate = end_date

        if (date.year() === end_date.year()) {
            setStart(date)
            setStartDate(date)
        } else {
            setStart(date)
            setStartDate(date)
            tmpDate.set('year', date.year())
            setEnd(tmpDate)
            setEndDate(tmpDate)


        }
    }

    const setEndDateForKrs = (date) => {
        let tmpDate = end_date
        if (date.year() === start_date.year()) {
            setEnd(date)
            setEndDate(date)
        } else {
            setEnd(date)
            setEndDate(date)
            let tmpDate = start_date
            tmpDate.set('year', date.year())
            setStart(tmpDate)
            setStartDate(tmpDate)


        }
    }
        useEffect(() => {
        if (checkIfActivePlotNeedsOpkFilter) {
            makeStartDateSameAsEnd()
        }
    }, [active_plot])

    const makeStartDateSameAsEnd = () => {
        setStart(end_date)
        setStartDate(end_date)
    }



    return (
        <IndicatorsPage>
            <Row>
                <Col className="ml-auto mr-auto" md="12">                    
                    <Card>
                        <CardBody>
                             <Row>
                                <Col>
                                    <DataFilters/>
                                </Col>
                                <Col>
                                    <FilterAvailableDataPoints/>
                                </Col>
                                    {!checkIfActivePlotNeedsOpkFilter() &&  <Col md="3" className={"okraglaczki nowaOkr dateSelectWskazniki"} color={"aotmit"} style={{"border-color":"green"}}>
                                    <ReactDatetime
                                        inputProps={{
                                        className: "form-control ",
                                        placeholder: "data początkowa",
                                        color: "aotmit",
                                        }}
                                        value={start_date}
                                        timeFormat={false}
                                        dateFormat={"YYYY-MM"}
                                        locale="pl"
                                        onChange={(date)=>{ setNewStartDate(date)}}
                                    />
                                </Col>}
                                <Col md={checkIfActivePlotNeedsOpkFilter()? {offset:3 ,size:3} :{size:3}} className={"okraglaczki dateSelectWskazniki"}>
                                    <ReactDatetime
                                        inputProps={{
                                        className: "form-control",
                                        placeholder: "data końcowa",
                                        }}
                                        timeFormat={false}
                                        dateFormat={"YYYY-MM"}
                                        locale="pl"
                                        value={end_date}
                                        onChange={(date)=>{ setNewEndDate(moment(date.endOf("month").format("YYYY-MM-DD")))}}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>

            {/* Filters */}
            <Col xl="2" md="3" sm="12">
                <FilterPanel/>
            </Col>


            {/* Chart */}
            <Col xl="10" md="9" sm="12">
                <Benchmark/>
            </Col>


             </Row>
            {/*<IndicatorDescription/>*/}
    </IndicatorsPage>
    )
}

// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators,
    Filters: state.Filters,

});


export default connect(mapStateToProps, {
    setStartDate,
    setEndDate,
})(ComparativeIndicatorsPage)
